import React, { useState, useEffect, useCallback } from "react";
import MaterialTable from "material-table";
import DetailEmployeeButton from "../../../components/DetailEmployeeButton";

function Employees(props) {
  const [state, setState] = useState({
    columns: [
      { title: "Nome", field: "name" },
      { title: "CPF", field: "cpf" },
      { title: "Função", field: "function" }, // 3
      { title: "Setor", field: "sector" }, // 4
      { title: "Status", field: "status" }, // 5
      {
        title: "Documentos / Integrações",
        render: rowData => (
          <DetailEmployeeButton
            data={rowData}
            CompanyTypeId={props.CompanyTypeId}
            CompanyStatusId={props.CompanyStatusId}
          />
        )
      }
    ],
    employees: null,
    loading: false
  });
  const curPage = localStorage.getItem('PAGE_EMPLOYEE_COMPANY');
  const pageSize = localStorage.getItem('PAGE_SIZE');
  var intervalPage = null;
  let auxCount = 1;

  useEffect(() => {
    intervalPage = setInterval(() => {
      if (curPage != 0)
        document.getElementsByClassName("material-icons MuiIcon-root")[10].click();
      if (auxCount >= curPage) 
        stopInterval();
      auxCount = auxCount + 1;
    }, 500);
  }, []);

  const stopInterval = () => {
    clearInterval(intervalPage);
  }

  const fetchMyAPI = useCallback(async () => {
    setState({ ...state, loading: true });

    if (props.employees !== null && props.employees.length !== 0) {
      const data = props.employees.map(item => {
        return {
          id: item.id,
          name: item.name,
          cpf: item.cpf,
          function: item.Function.description,
          sector: item.Sector.name,
          status: item.EmployeeStatus.description,
          integrations: JSON.stringify(item.IntegrationSchedules)
        };
      });

      setState({ ...state, employees: data, loading: false });
    }
  });

  useEffect(() => {
    fetchMyAPI();
  }, [props]);

  return (
    <>
      <MaterialTable
        title=""
        isLoading={state.loading}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsSelect: "linhas",
            firstTooltip: "Primeira",
            previousTooltip: "Anterior",
            nextTooltip: "Próxima",
            lastTooltip: "Última"
          },
          body: {
            emptyDataSourceMessage: "Não há dados a serem exibidos",
            editRow: {
              saveTooltip: "Salvar",
              cancelTooltip: "Cancelar",
              deleteText: "Tem certeza que deseja deletar este registro?"
            },
            addTooltip: "Adicionar",
            deleteTooltip: "Deletar",
            editTooltip: "Editar"
          },
          header: {
            actions: "Deletar"
          },
          toolbar: {
            searchPlaceholder: "Pesquisar"
          }
        }}
        columns={state.columns}
        data={state.employees}
        options={{
          actionsColumnIndex: -1,
          pageSize: pageSize == undefined ? 5 : pageSize
        }}
        onChangePage={(page) => {
          localStorage.setItem('PAGE_EMPLOYEE_COMPANY', page);
        }}
        onChangeRowsPerPage={(pageSize) => {
          localStorage.setItem('PAGE_SIZE', pageSize);
        }}
      />
    </>
  );
}

export default Employees;
